import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListState } from '@usf/ngrx-list';
import { GroupRow } from '../list-detail-management/model/list-detail-management-view.model';

@Component({
  template: '',
})
export class ListGroupsBaseComponent {
  @Input() list: ListState;
  @Input() groups: GroupRow[];
  @Input() selectedGroup: string;
  @Output() changeGroupEmitter: EventEmitter<string> = new EventEmitter();
  @Output() dragDropEmitter: EventEmitter<
    CdkDragDrop<number, number>
  > = new EventEmitter();
  @Output() createGroupEmitter: EventEmitter<string> = new EventEmitter();

  constructor() {}

  changeSelectedGroup(group: GroupRow, elementId: string) {
    this.changeGroupEmitter.emit(group?.groupName);
    let id =
      group?.groupName !== 'Unassigned Group'
        ? elementId
        : 'list-groups-unassigned-button';
    if (id) {
      this.scrollToSelectedGroup(id);
    }
  }

  onDragDropped(event: CdkDragDrop<number, number>) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    this.dragDropEmitter.emit(event);
  }

  scrollToSelectedGroup(elementId: string) {
    document.getElementById(elementId).scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }
}
